import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { Router, ActivatedRoute, RouterLink } from '@angular/router';
import { LogoComponent } from '../logo/logo.component';

import { environment } from '../../../../environments/environment';
import { BannerComponent } from '../banner/banner.component';
import { NgTemplateOutlet } from '@angular/common';
import { CreateMenuButtonComponent } from "../create-menu-button/create-menu-button.component";

@Component({
  selector: 'app-nav',
  imports: [LogoComponent, BannerComponent, RouterLink, NgTemplateOutlet, CreateMenuButtonComponent],
  templateUrl: './nav.component.html',
  styleUrl: './nav.component.scss',
})
export class NavComponent implements OnInit {
  isSmallScreen = false;
  isMenuActive: boolean = false;
  currentLink: string = '';
  isScrolled = false;

  menuLinks: any[] = [
    {
      name: 'Come funziona',
      link: '/come-funziona',
    },
    {
      name: 'Ricette & Ingredienti',
      link: '/ingredienti',
    },
    {
      name: 'I nostri nutrizionisti',
      link: '/nostri-nutrizionisti',
    },
    {
      name: 'Opinioni',
      link: '/opinioni',
    },
    {
      name: 'Blog',
      link: '/blog',
    },

    {
      name: 'Salute',
      links: [
        {
          titolo: 'Diabete nel cane',
          route: '/diabete',
        },
        {
          titolo: 'Diarrea nel cane',
          route: '/diarrea',
        },
        {
          titolo: 'Problemi di digestione',
          route: '/digestione',
        },
        {
          titolo: 'Utilizzo delle fibre nelle diete dei cani',
          route: '/fibre',
        },
        {
          titolo: 'Cibo ipoallergenico',
          route: '/ipoallergenico',
        },
        // {
        //   titolo: 'Pancreatite nel cane',
        //   route: '/pancreatite',
        // },
        // {
        //   titolo: 'Torsione dello stomaco',
        //   route: '/torsione-stomaco',
        // },
        {
          titolo: 'Problemi alle vie urinarie',
          route: '/vie-urinarie',
        },

        {
          titolo: 'Il tuo cane vomita?',
          route: '/vomito',
        },
      ],
    },
  ];

  isSaluteMenuOpened: boolean = false;

  constructor(
    public router: Router,
    private route: ActivatedRoute,
    private elRef: ElementRef
  ) {}

  @HostListener('window:resize', [])
  onWindowResize() {
    this.checkScreenSize();
    this.checkMenuLinks();
  }
  @HostListener('window:scroll', [])
  onScroll() {
    this.checkNavBackground();
  }

  ngOnInit() {
    this.router.events.subscribe((value) => {
      this.currentLink = this.router.url.toString();
    });

    this.checkNavBackground();
    this.checkScreenSize();
    this.checkMenuLinks();
  }

  toggleMenu(): void {
    this.isMenuActive = !this.isMenuActive;
    if (this.isMenuActive === false) {
      this.isSaluteMenuOpened = false;
    }

    this.toggleBodyScroll(this.isMenuActive);
  }

  handleLinkClick(name: string, route: string): void {
    if (name === 'Salute') {
      this.isSaluteMenuOpened = !this.isSaluteMenuOpened;
      if (this.isSmallScreen) {
        this.isMenuActive = true;
      }
    } else {
      this.isSaluteMenuOpened = false;
      this.isMenuActive = false;
    }

    this.toggleBodyScroll(this.isMenuActive);
  }

  toggleBodyScroll(isActive: boolean): void {
    if (isActive && this.isSmallScreen) {
      document.body.classList.add('menu-open');
    } else {
      document.body.classList.remove('menu-open');
    }
  }

  onSaluteMenuClose() {
    this.isSaluteMenuOpened = false;
  }

  checkScreenSize() {
    this.isSmallScreen = window.innerWidth <= 1439;
  }

  checkMenuLinks() {
    if (
      this.isSmallScreen &&
      !this.menuLinks.find((el) => el.link == '/home')
    ) {
      this.menuLinks.unshift({ name: 'Home', link: '/home' });
    } else if (
      !this.isSmallScreen &&
      this.menuLinks.find((el) => el.link == '/home')
    ) {
      this.menuLinks.splice(0, 1);
    }
  }

  private checkNavBackground() {
    const scrolled = window.scrollY > 0;
    this.isScrolled = scrolled;
  }

  shouldNavBeFixed(): boolean {
    return this.currentLink === '/home' && !this.isSmallScreen;
  }

  goToLogin() {
    window.open(environment.appUrl + 'tabs/' + 'cibo', '_blank');
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(ev: MouseEvent) {
    if (this.isSmallScreen) return;
    const target = ev.target as Node;
    const clickedInside = this.elRef.nativeElement.contains(target);
    if (!clickedInside) {
      this.isSaluteMenuOpened = false;
    }
  }
}
